
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-13bb54f8\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./home.scss")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./home.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-13bb54f8\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./home.vue.html"),
  /* scopeId */
  "data-v-13bb54f8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/home/home.vue.html
// module id = PrlI
// module chunks = 2